import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [

  {path: '/',               name: 'preNews',       component: ()=> import('../views/preNews.vue'),   meta:{showNav: true}},     // 提前预约 redirect: '/preNews',
  {path: '/queryNews',      name: 'queryNews',    component: ()=> import('../views/queryNews.vue'), meta:{showNav: true}},      // 预约查询
  {path: '/hallStatus',      name: 'hallStatus',  component: ()=> import('../views/hallStatus.vue'), meta:{showNav: true}},     // 大厅实况
  {path: '/index', name: 'index' , component: () => import('../views/index.vue'), meta:{showNav: true}},

  {path: '/nav',          name: 'nav',          component: ()=> import('../components/nav')},               // 导航栏 点击切换页面
  {path: '/preCode',        name: 'preCode',      component: ()=> import('../components/one/preCode')},     // 预约成功信息
  {path: '/preCode1',        name: 'preCode1',      component: ()=> import('../components/one/preCode1')},     // 预约成功信息
  {path: '/addr',        name: 'addr',         component: ()=> import('../components/two/addr')},           // 地址电话
  {path: '/preMsg',       name: 'preMsg',       component: ()=> import('../components/three/preMsg')},      // 查询预约信息
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// 全局前置 导航守卫
router.beforeEach((to,from,next)=>{
        if( to.path == '/'){ next();}
        else if(to.path == '/queryNews'){ next();}
        else if(to.path == '/hallStatus'){next();}
        else if(to.path == '/index') {next();}
        else{ next('/');}
})


// 刷新时，滚动条位置不变
// const scrollBehavior = (to, from, savedPosition) => {

//   console.log("我在刷新")
//   if(to.hash){ return { selector: to.hash } }
// }


export default router